import { render, staticRenderFns } from "./scene23.vue?vue&type=template&id=439c7ab2&scoped=true&"
import script from "./scene23.vue?vue&type=script&lang=ts&"
export * from "./scene23.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "439c7ab2",
  null
  
)

export default component.exports